import { UpdateUserPackageRequest } from '@cbinsights/adminservice/adminservice';
import { request } from 'client/modules/common/utils/request';

export const updateUserPackage = (
  req: Partial<UpdateUserPackageRequest>
): Promise<void> =>
  request({
    url: '/service/adminservice/UpdateUserPackage',
    body: req,
  }).then((r) => r.body);
